import $ from 'jquery'

const body = document.body

const setThemeVars = () => {
    const documentWidth = document.documentElement.clientWidth
    const width = Math.abs(window.innerWidth - documentWidth)
    body.style.setProperty('--scrollbar-width', `${width}px`)

    const mainContainer = document.querySelector('#colophon > .container')
    const mainContainerWidth = mainContainer.clientWidth

    const col = document.querySelector('.vn-col-sizer')
    const colWidth = col.clientWidth

    const headerContainer = document.querySelector('.site-header')
    const headerContainerHeight = headerContainer.clientHeight

    const bigCTAImage = document.querySelector('.bigcta-block .container .image');

    if (bigCTAImage) {
        const bigCTAImageHeight = bigCTAImage.clientHeight;
        body.style.setProperty('--bigctaimage-height', `${bigCTAImageHeight}px`)
    }


    var documentHeight = document.documentElement.clientHeight;


    document.body.style.setProperty('--document-height', `${documentHeight}px`);


    body.style.setProperty(
        '--space-width',
        `${(documentWidth - mainContainerWidth) / 2 + 20}px`
    )

    body.style.setProperty('--container-width', `${mainContainerWidth}px`)
    body.style.setProperty('--main-width', `${documentWidth}px`)
    body.style.setProperty('--col-width', `${colWidth}px`)
    body.style.setProperty('--header-height', `${headerContainerHeight}px`)

}

setThemeVars()
window.addEventListener('load', setThemeVars)
window.addEventListener('resize', setThemeVars)

$('.vn-btn-terms button').on('click', function (e) {
    e.preventDefault()
    window.location.href = $(this).attr('data-url')
})

$('.menu-accordion').on('click', function (e) {
    e.preventDefault();
    $('.menu-container').addClass('open');
});

$('.menu-container .close').on('click', function (e) {
    e.preventDefault();
    $('.menu-container').removeClass('open');
});

document.addEventListener('DOMContentLoaded', function () {
    const formButton = document.querySelector('.form-button a');
    const menuItems = document.querySelectorAll('.menu-container ul.menu li');
    const backButton = document.querySelector('.back-button');
    const formContainer = document.querySelector('.form');
    const addressArea = document.querySelector('.address-area');

    formButton.addEventListener('click', function (e) {
        menuItems.forEach(item => {
            if (!item.classList.contains('form-button')) {
                item.style.display = 'none';
            }
        });

        if (window.innerWidth < 768) {
            addressArea.style.display = 'none';
        }

        formContainer.classList.add('show');
        backButton.classList.add('show');
    });

    backButton.addEventListener('click', function () {
        menuItems.forEach(item => {
            item.style.display = 'flex';
        });

        if (window.innerWidth < 768) {
            addressArea.style.display = 'flex';
        }

        formContainer.classList.remove('show');
        backButton.classList.remove('show');
    });

    const blocks = document.querySelectorAll('.vn-block, .feed-actor');

    const observerOptions = {
        root: null, // Utilise la fenêtre du navigateur comme conteneur
        rootMargin: '0px 0px -50px 0px',
        threshold: 0.2 // 20% du bloc doit être visible pour déclencher l'animation
    };

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
                observer.unobserve(entry.target); // Arrête d'observer une fois que l'animation a été déclenchée
            }
        });
    }, observerOptions);

    blocks.forEach(block => {
        observer.observe(block);
    });

});

$('a[href="#cookies"]').on('click', (e) => {
    e.preventDefault()
    window.openAxeptioCookies()
})
